import { IStore } from "../../model/runtime/state/Store";
import { UserPreferences } from "../../common/Constants";
import { ILanguage } from "../../model/language/Language";
import { ICredentialsService } from "../../../authentication/service/CredentialsService";
import { ILanguageService } from "../../service/language/LanguageService";
import Application from "../../../Application";
import FindResourceEntryInteractor from "../app/crud/FindResourceEntryInteractor";
import { IOrganisation } from "../../../organisations/model/Organisation";
import OrganisationMapper from "../../../organisations/service/OrganisationMapper";
import OrganisationParamMapper from "../../../organisations/service/OrgansationParamMapper";
import { IStorageService } from "../../service/StorageService";

export default class LoadDefaultStateInteractor {
  private application: Application;
  private languageService: ILanguageService;
  private store: IStore;
  private credentialsService: ICredentialsService;
  private findOrganisation: FindResourceEntryInteractor<IOrganisation>;
  private storageService: IStorageService;

  constructor({
    application,
    store,
    languageService,
    credentialsService,
    findResourceEntry,
    storageService
  }: any) {
    this.application = application;
    this.store = store;
    this.languageService = languageService;
    this.credentialsService = credentialsService;
    this.findOrganisation = findResourceEntry;
    this.storageService = storageService;
  }

  async getCurrentLanguageCode() {
    const currentLanguage = await this.credentialsService.getLanguage();
    return String(currentLanguage);
  }

  async execute(organisationId?: string) {
    const languages = await this.languageService.getLanguages();
    let currentLanguageCode = await this.getCurrentLanguageCode();
    currentLanguageCode = currentLanguageCode
      ? currentLanguageCode
      : UserPreferences.DEFAULT_LANGUAGE;

    let selectedLanguage = languages.find(
      (langugage: ILanguage) => langugage.code === currentLanguageCode
    );
    if (!selectedLanguage) {
      selectedLanguage = languages[0];
    }
    if (!organisationId) {
      organisationId = await this.storageService.get("organisationId");
    }
    if (organisationId) {
      this.findOrganisation
        .execute(
          "/organisations",
          OrganisationMapper,
          OrganisationParamMapper,
          organisationId
        )
        .then((organisation) => {
          this.storageService.save("organisationId", organisationId);
          this.store.update({
            organisation
          });
        });
    }

    this.store.update({
      languages,
      selectedLanguage,
      application: this.application
    });
  }
}
